define('commons/coverage-map-overlay',['jquery', 'async!google-maps'], function($) {

    var CoverageOverlay = function(bounds, imageSrc, map, opacity, enableOver, isDensity, isLandCover) {

        // Now initialize all properties.
        this.bounds = bounds;
        this.imageSrc = imageSrc;
        this.image = null;
        this.map = map;
        this.opacity = opacity;
        this.enableOver = enableOver;
        this.isDensity = isDensity;
        this.isLandCover = isLandCover;

        // We define a property to hold the image's
        // div. We'll actually create this div
        // upon receipt of the add() method so we'll
        // leave it null for now.
        this.div = null;
        // create div only to catch mouse event
        this.divMouse = null;
        
        // Canvas
        this.canvas = document.createElement('canvas');
        
        // Is canvas ready
        this.isCanvasReady = !!this.canvas.getContext;
        if(this.isCanvasReady) {
            this.canvasCtx = this.canvas.getContext("2d");
        }

        // TO BE OVERRIDDEN
        this.onOverlayMove = function(event, pixel) {};
        this.onOverlayOut = function() {};
        
        // Explicitly call setMap() on this overlay
        this.setMap(map);
      };

      CoverageOverlay.prototype = new google.maps.OverlayView();

      CoverageOverlay.prototype.onAdd = function() {

          // Note: an overlay's receipt of onAdd() indicates that
          // the map's panes are now available for attaching
          // the overlay to the map via the DOM.

          // Create the DIV and set some basic attributes.
          var div = document.createElement('DIV');
          div.style.border = "none";
          div.style.borderWidth = "0px";
          div.style.position = "absolute";
          var $div = $(div);
          
          // create the DIV to catch event
          var divMouse = document.createElement('DIV');
          divMouse.style.border = "none";
          divMouse.style.borderWidth = "0px";
          divMouse.style.position = "absolute";
          var $divMouse = $(divMouse);
          if(this.enableOver) {
              $divMouse.mousemove($.proxy(this.onMouseMove, this));
              $divMouse.mouseout($.proxy(this.onOverlayOut, this));
          }
          
          // Set the overlay's div property to this DIV
          if(this.div) {
              $(this.div).remove();
          }
          this.div = div;
          if(this.divMouse) {
              $(this.divMouse).remove();
          }
          this.divMouse = divMouse;

          // Create an IMG element and attach it to the DIV.
          var img = document.createElement("img");  
          this.image = img;
          
          if(this.isCanvasReady) {
              img.onload = $.proxy(this.onImageLoaded, this);
              this.canvas.width = 1;  
              this.canvas.height = 1;
          } else {
              div.appendChild(img);
              img.style.width = "100%";
              img.style.height = "100%";
          }
          img.src = this.imageSrc;
          
          // We add an overlay to a map via one of the map's panes.
          // We'll add this overlay to the overlayLayer pane.
          var panes = this.getPanes();
          if (this.isDensity) {
              if(!panes.overlayLayer.density) {
                  panes.overlayLayer.density = document.createElement('div');
                  panes.overlayLayer.density.style.position = "absolute";
                  $(panes.overlayLayer).prepend(panes.overlayLayer.density);
              }
              panes.overlayLayer.density.appendChild(div);
          } else if (this.isLandCover) {
              if(!panes.overlayLayer.landCover) {
                  panes.overlayLayer.landCover = document.createElement('div');
                  panes.overlayLayer.landCover.style.position = "absolute";
                  $(panes.overlayLayer).prepend(panes.overlayLayer.landCover);
              }
              panes.overlayLayer.landCover.appendChild(div);
          } else {
              if(!panes.overlayLayer.coverage) {
                  panes.overlayLayer.coverage = document.createElement('div');
                  panes.overlayLayer.coverage.style.position = "absolute";
                  panes.overlayLayer.coverage.style.zIndex = "1";
                  $(panes.overlayLayer).prepend(panes.overlayLayer.coverage);
              }
              panes.overlayLayer.coverage.appendChild(div);
              if(!panes.overlayMouseTarget.coverage) {
                  panes.overlayMouseTarget.coverage = document.createElement('div');
                  panes.overlayMouseTarget.coverage.style.position = "absolute";
                  $(panes.overlayMouseTarget).prepend(panes.overlayMouseTarget.coverage);
              }
              panes.overlayMouseTarget.coverage.appendChild(divMouse);
          }
          this.setOpacity(this.opacity);
      };

      CoverageOverlay.prototype.onImageLoaded = function() {
          this.image.realWidth = this.image.width;
          this.image.realHeight = this.image.height;
          this.image.style.width = "100%";
          this.image.style.height = "100%";
          // for maybe later used
          if (false) {
              this.changeColor(this.image);
          }
          if(this.div) {
              this.div.appendChild(this.image);
          }
      };

      CoverageOverlay.prototype.onMouseMove = function(event) {
          if(this.isCanvasReady && this.image) {
              var pos = $(this.image).offset();
              var pixel = this.getPixel(event.pageX - parseInt(pos.left), event.pageY - parseInt(pos.top));
              var onPixel = (pixel.a === 0);
              this.div.style.cursor = (onPixel ? "" : "default");
              this.onOverlayMove(event, pixel);
          }
      };

      CoverageOverlay.prototype.getPixel = function(x, y) {
          var xr = this.image.width / this.image.realWidth;
          var yr = this.image.height / this.image.realHeight;
          this.canvasCtx.clearRect(0, 0, 1, 1);
          var startX = Math.min(this.image.realWidth, Math.max(0, (x-xr/2)/xr));
          var startY = Math.min(this.image.realHeight, Math.max(0, (y-yr/2)/yr));
          this.canvasCtx.drawImage(this.image, startX, startY, 1, 1, 0, 0, 1, 1);

          var raw = this.canvasCtx.getImageData(0, 0, 1, 1);
          var pixel = {
              p: {x: x, y: y},
              r: raw.data[0],
              g: raw.data[1],
              b: raw.data[2],
              a: raw.data[3]
          };
          return pixel;
      };

      CoverageOverlay.prototype.draw = function() {

          // Size and position the overlay. We use a southwest and northeast
          // position of the overlay to peg it to the correct position and size.
          // We need to retrieve the projection from this overlay to do this.
          var overlayProjection = this.getProjection();

          // Retrieve the southwest and northeast coordinates of this overlay
          // in latlngs and convert them to pixels coordinates.
          // We'll use these coordinates to resize the DIV.
          var sw = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest());
          var ne = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast());

          // Resize the image's DIV to fit the indicated dimensions.
          var div = this.div;
          div.style.left = sw.x + 'px';
          div.style.top = ne.y + 'px';
          div.style.width = (ne.x - sw.x) + 'px';
          div.style.height = (sw.y - ne.y) + 'px';

          // Resize the mouse's DIV to fit the indicated dimensions.
          var divMouse = this.divMouse;
          divMouse.style.left = sw.x + 'px';
          divMouse.style.top = ne.y + 'px';
          divMouse.style.width = (ne.x - sw.x) + 'px';
          divMouse.style.height = (sw.y - ne.y) + 'px';
      };

      CoverageOverlay.prototype.onRemove = function() {
          $(this.div).remove();
          this.div = null;
          $(this.divMouse).remove();
          this.divMouse = null;
      };

      /** Opacity: from 0 to 100 */
      CoverageOverlay.prototype.setOpacity = function(opacity) {
          var panes = this.getPanes();
          if(panes && panes.overlayLayer) {
              var pane;
              if (this.isDensity && panes.overlayLayer.density) {
                  pane = panes.overlayLayer.density;
              } else if (this.isLandCover && panes.overlayLayer.landCover) {
                  pane = panes.overlayLayer.landCover;
              } else if (panes.overlayLayer.coverage) {
                  pane = panes.overlayLayer.coverage;
              }
              if (pane) {
                  opacity = Math.min(100, Math.max(0, opacity));
                  if(opacity === 0) {
                      pane.style.visibility = "hidden";
                  } else {
                      pane.style.visibility = "visible";
                      pane.style.opacity = (opacity / 100);
                  }
              }
          }
      };
      
      CoverageOverlay.prototype.hexToRGB = function(hex) {
          var long = parseInt(hex.replace(/^#/, ""), 16);
          return {
              R: (long >>> 16) & 0xff,
              G: (long >>> 8) & 0xff,
              B: long & 0xff
          };
      }

      CoverageOverlay.prototype.changeColor = function(img) {
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;

          var originalPixels = null;

          ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, img.width, img.height);
          originalPixels = ctx.getImageData(0, 0, img.width, img.height);

          img.onload = null;

          if(!originalPixels) return; // Check if image has loaded
          var newColorMap = [
           ["#106D10", "#FFFBC3"],
           ["#018200", "#DCCE00"],
           ["#02DC00", "#018200"],
           ["#00FF00", "#0000FF"],
           ["#92AE2F", "#F7A5FF"],
           ["#DCCE00", "#FFCC80"],
           ["#FFFBC3", "#DC812D"],
           ["#F7A5FF", "#AA0000"],
           ["#FFC7AE", "#FF0000"]
           ];
          var newColorRGB = [];
          for (var j = 0; j < newColorMap.length; j++) {
              newColorRGB[j] = [this.hexToRGB(newColorMap[j][0]), this.hexToRGB(newColorMap[j][1])];
          }

          for(var I = 0, L = originalPixels.data.length; I < L; I += 4) {
              if(originalPixels.data[I + 3] > 0) {// If it's not a transparent pixel
                  for (var j = 0; j < newColorRGB.length; j++) {
                      var oldColor = newColorRGB[j][0];
                      if (originalPixels.data[I] == oldColor.R && originalPixels.data[I + 1] == oldColor.G && originalPixels.data[I + 2] == oldColor.B) {
                          var newColor = newColorRGB[j][1];
                          originalPixels.data[I] = newColor.R;
                          originalPixels.data[I + 1] = newColor.G;
                          originalPixels.data[I + 2] = newColor.B;
                          break;
                      }
                  }
              }
          }

          ctx.putImageData(originalPixels, 0, 0);
          this.image.src = canvas.toDataURL("image/png");;
      }

      return CoverageOverlay;
});

